<template>
  <!-- CSS命名参考BEM规范 -->
  <div>
    <div class="navTop">
      <a class="navTop__logo" href="/"></a>
      <div class="navTop__headermid">
        <div class="navTop__dropbox">
          <a class="navTop__a--dropbox" href="/console/#/main/overview">
            <p style="margin: 0;">管理控制台</p>
          </a>
        </div>
        <!-- 产品与服务入口调整 -->
        <!--<div class="navTop__dropbox" @mouseover.stop="onShowNavAllPanel(true)">-->
          <!--<a class="navTop__a&#45;&#45;dropbox">产品与服务</a>-->
        <!--</div>-->
        <div class="navTop__icon--floatRight">
          <el-badge hidden :value="20" class="item" :is-dot="true">
            <a href="https://www.unicloud.com/support">
              <i class="icon icon-question_sign" title="帮助中心"></i>
            </a>
          </el-badge>
        </div>
        <div class="navTop__icon--floatRight">
          <el-dropdown trigger="hover" @command="onHandleCommand"  v-if="messageCount > 0">
            <el-badge :value="20" :is-dot="true">
              <i class="icon icon-message_center" :title="`您有${messageCount}未读条消息`" @click="onGoToMessageCenter"></i>
            </el-badge>
            <el-dropdown-menu  slot="dropdown" class="navTop__dropdownMenu"  v-if="messageCount > 0">
              <el-dropdown-item v-for="(item, index) in unreadMessage"
                                command="unread"
                                :key="index">
                <p class="message-content">
                  <span style="margin-right: 10px">{{item.title}}</span>{{item.content}}
                </p>
                <p style="border-bottom: 1px solid #babdc4">{{format(item.createTime, 'yyyy-MM-dd h:m:s')}}</p>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-badge v-else>
            <i class="icon icon-message_center" title="消息中心" @click="onGoToMessageCenter"></i>
          </el-badge>
        </div>
        <div class="navTop__dropbox--floatRight"
             style="margin-right:25px">
          <el-dropdown trigger="hover" @command="onHandleCommand">
              <div>工单
                <i class="el-icon-arrow-down"></i>
              </div>
            <el-dropdown-menu slot="dropdown" class="navTop__dropdownMenu">
              <el-dropdown-item class="dropdown-item" command="commitOrder">发起工单</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command="orderList">我的工单</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="navTop__dropbox--floatRight">
          <el-dropdown trigger="hover" @command="onHandleCommand" ref="expenseDropdown">
            <div>费用
              <i class="el-icon-arrow-down"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="navTop__dropdownMenu">
              <div class="navTop__msg" v-show="userInfo.type == 'PUBLIC'">
                <div style="color:#333">可用余额</div>
                <div>
                  <span style=" font-size: 16px; color: #999">&yen;&nbsp;</span>
                  <span class="navTop__account"
                        @click="onGoToExpenseCenter">{{integerAccountRemainder}}</span>
                  <span style="color:rgb(244, 181, 100); cursor:pointer; font-size: 16px;"
                        v-if="decimalAccountRemainder"
                        @click="onGoToExpenseCenter">.{{decimalAccountRemainder}}</span>
                  <el-button type="text" style="margin-left: 20px" @click.stop="onGoToRecharge">充值</el-button>
                </div>
                <div>
                  <el-button style="width: 80px"
                             @click.stop="onGoToAccountDetail('coupon')">体验券</el-button>
                  <el-button type="primary"
                             style="width: 80px"
                             @click.stop="onGoToAccountDetail('renewal')">续费</el-button>
                </div>
              </div>
              <el-dropdown-item class="dropdown-item" command="accountOverviewTable">我的订单</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command="expRecDetail">收支明细</el-dropdown-item>
              <el-dropdown-item class="dropdown-item" command="expenseCenter">费用中心</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="navTop__dropbox--floatRight" v-show="isShowRegionSelect">
          <el-dropdown trigger="hover" @command="onChangeRegion">
            <span class="el-dropdown-link navTop__regionDropdown">
                <i class="icon icon-map_marker"></i>
                <div>{{selectedRegionName}}</div>
                <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="width: 150px;" class="navTop__dropdownMenu">
              <el-dropdown-item :command="item.zg_id" v-for="(item,index) in region" :key="index">{{item.zg_name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="navTop__user">
        <el-popover placement="bottom" trigger="hover" :visible-arrow="false" popper-class="navTop__popover" v-model="isShowUserInfo">
          <div slot="reference" class="navTop__userAvatar" :title="userInfo.name"></div>
          <div class="navTop__userPop">
            <div class="navTop__username">
              <img src="../../assets/images/headSculpture.svg" width="30px" height="30px" alt="user-icon" style="vertical-align:middle;margin-right:10px;">
              <span v-if="userInfo.type == 'PUBLIC'">{{userInfo.name}}</span>
              <span v-else-if="userInfo.type == 'CHILD'">{{userInfo.childUserName}} 子账号</span>
            </div>
            <a :href="hrefVisitContral" class="navTop__userEntrance" @click="isShowUserInfo = false" v-show="userInfo.type == 'PUBLIC' && userInfo.whiteListFlag === 1">
              <span class="navTop__entranceLogo">
                <i class="icon icon-iam"></i>
              </span>
              <span>访问控制</span>
            </a>
            <a :href="userInfo.type == 'PUBLIC' ? hrefUserBase : hrefChildBase" class="navTop__userEntrance" @click="isShowUserInfo = false">
              <span class="navTop__entranceLogo">
                <i class="icon icon-file_fill_alt"></i>
              </span>
              <span v-if="userInfo.type == 'PUBLIC'">基本资料</span>
              <span v-else-if="userInfo.type == 'CHILD'">子账号信息</span>
            </a>
            <a :href="hrefUserSafeSet" class="navTop__userEntrance" @click="isShowUserInfo = false" v-show="userInfo.type == 'PUBLIC'">
              <span class="navTop__entranceLogo">
                <i class="icon icon-cog"></i>
              </span>
              <span>安全设置</span>
            </a>
            <a :href="hrefAccessKey" class="navTop__userEntrance" @click="isShowUserInfo = false" v-show="userInfo.type == 'PUBLIC'">
              <span class="navTop__entranceLogo">
                <i class="icon icon-key"></i>
              </span>
              <span>AccessKey</span>
            </a>
          </div>
          <div class="navTop__logout" @click="onLogout">退出</div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import actionTypes from '../../store/action-types';
import mutationTypes from '../../store/mutation-types';
import consolePanelReq from "../../assets/js/request/otherService/consolePanelReq";

export default {

  data() {
    return {
      hrefVisitContral: `/console/#/iam/iamOverview`,
      hrefUserBase: `/console/#/main/iam/userInfo`,
      hrefUserSafeSet: `/console/#/main/iam/userSafeSet`,
      hrefAccessKey: `/console/#/main/iam/accessKey`,
      hrefChildBase: `/console/#/main/iam/subaccountInfo`,
      isShowNavAllPanel: false,
      isShowUserInfo: false
    }
  },

  computed: {
    format() {
        return function(date, format) {
            return this.formatDate(date, format)
        };
    },

    userInfo() {
      return this.$store.state.userInfo;
    },

    region() {
      return this.$store.state.region;
    },

    pendingOrder() {
      return this.$store.state.pendingOrder;
    },
    messageCount() {
      return this.$store.state.messageCount;
    },

    unreadMessage() {
      return this.$store.state.message;
    },

    // 可用余额
    accountRemainder() {
      return this.$store.state.accountRemainder;
    },

    // 账户余额整数位
    integerAccountRemainder() {
      return this.accountRemainder.toString().split('.')[0];
    },

    // 账户余额小数位
    decimalAccountRemainder() {
      let decimal = this.accountRemainder.toString().split('.')[1];
      return decimal ? decimal.length > 1 ? decimal : decimal+'0' : '00';
    },

    isShowRegionSelect() {
      return this.$store.state.isShowRegionSelect;
    },

    selectedRegionName() {
      let name = this.region.find((e) => {
        return e.zg_id == this.$store.state.selectedRegionId
      });
      return name ? name.zg_name : "";
    }
  },

  methods: {
    formatDate(date, format) {
        let da = new Date();
        const time = {
            "M+" : da.getMonth()+1,                 //月份
            "d+" : da.getDate(),                    //日
            "h+" : da.getHours(),                   //小时
            "m+" : da.getMinutes(),                 //分
            "s+" : da.getSeconds(),                 //秒
            "q+" : Math.floor((da.getMonth()+3)/3), //季度
            "S"  : da.getMilliseconds()             //毫秒
        };
        if(/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (da.getFullYear()+"").substr(4 - RegExp.$1.length));
        }
        for(let k in time) {
            if(new RegExp("("+ k +")").test(format)){
                format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (time[k]) : (("00"+ time[k]).substr((""+ time[k]).length)));
            }
        }
        return format;
    },
    // 显示 <nav-all-panel> 组件
    onShowNavAllPanel(status) {
      this.isShowNavAllPanel = status;
    },

    onChangeRegion(command) {
      localStorage.removeItem("isInit");
      localStorage.removeItem("isInitialization");
      this.$store.commit(mutationTypes.SET_SELECTED_REGION_ID, command);
    },

    //点击账户余额跳转到费用中心
    onGoToExpenseCenter() {
      this.$refs.expenseDropdown.hide();
      window.location.href = `/console/#/main/expense/resourcesCheck`;
    },

    //点击充值进入充值页面
    onGoToRecharge() {
        this.$refs.expenseDropdown.hide();
        window.location.href = `/console/#/main/expense/recharge`;
    },

    // 跳转到账户详情
    onGoToAccountDetail(type) {
      this.$refs.expenseDropdown.hide();
      switch (type) {
        case 'coupon':
          window.location.href = `/console/#/main/expense/coupon`;
          break;
        case 'receiptManager':
          window.location.href = `/console/#/main/expense/receiptManager`;
          break;
        case 'renewal':
          window.location.href = `/console/#/main/expense/renewal`;
          break;
        case 'recharge':
          window.location.href = `/console/#/main/expense/recharge`;
          break;
        case 'shoppingCenter':
          window.location.href = `/console/#/main/expense/shoppingCenter`;
          break;
        default:
          break;        
      }
    },

    // 下拉框跳转
    onHandleCommand(command) {
      switch (command) {
        case 'expenseCenter':
          window.location.href = `/console/#/main/expense/resourcesCheck`;
          break;
        case 'resourceBill':
          window.location.href = `/console/#/main/expense/resourceBill`;
          break;
        case 'accountOverviewTable':
          window.location.href = `/console/#/main/expense/accountOverviewTable`;
          break;
        case 'expRecDetail':
          window.location.href = `/console/#/main/expense/expRecDetail`;
          break;
        case 'commitOrder':
          window.location.href = `/console/#/main/workorder/commitOrder`;
          break;
        case 'unread':
          window.location.href = `/console/#/main/iam/messageCenter/unread`;
          break;
        case 'orderList':
          window.location.href = `/console/#/main/workorder/orderlist`;
          break;
        default:
          break;        
      }
    },

    onGoToMessageCenter() {
      let url = this.messageCount > 0 ? `/console/#/main/iam/messageCenter/unread` : `/console/#/main/iam/messageCenter/read`;
      window.location.href = url;
    },

    onLogout() {
      if(this.userInfo.type == 'PUBLIC') {
        consolePanelReq.logout()
          .then(res => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("ai-select-region");
            sessionStorage.removeItem("ai-region-list");
            sessionStorage.removeItem("navLeftMenu");
            localStorage.removeItem("isInit");
            localStorage.removeItem("isInitialization");
            window.location.href = "/login";
          }).catch(err => {
            console.error(err);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("ai-select-region");
            sessionStorage.removeItem("ai-region-list");
            sessionStorage.removeItem("navLeftMenu");
            localStorage.removeItem("isInit");
            localStorage.removeItem("isInitialization");
            window.location.href = "/login";
          });
      } else if(this.userInfo.type == 'CHILD') {
        consolePanelReq.childLogout()
          .then(res => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("ai-select-region");
            sessionStorage.removeItem("ai-region-list");
            sessionStorage.removeItem("navLeftMenu");
            localStorage.removeItem("isInit");
            localStorage.removeItem("isInitialization");
            window.location.href = "/iam/login";
          }).catch(err => {
            console.error(err);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("ai-select-region");
            sessionStorage.removeItem("ai-region-list");
            sessionStorage.removeItem("navLeftMenu");
            localStorage.removeItem("isInit");
            localStorage.removeItem("isInitialization");
            window.location.href = "/iam/login";
          });
      }
    }
  }
};
</script>

<style scoped>
.navTop {
  position: fixed;
  top: 0;
  width: 100%;
  height: 50px;
  z-index: 300;
  background-color: #1472DC;
  line-height: 50px;
  color: rgba(255, 255, 255, 1);
  padding: 0;
}

.navTop__logo {
  width: 130px;
  height: 100%;
  /*border-right: solid 1px #40444D;*/
  background-image: url(../../assets/images/logo01.svg);
  background-image: url(../../assets/images/logo.png);
  background-repeat: no-repeat;
  background-position: center center;
  display: inline-block;

  background-size: 70%;
  background-position: 50%;
}

.navTop__headermid {
  position: absolute;
  top: 0;
  left: 130px;
  height: 100%;
  width: calc(100% - 200px);
}

.navTop__dropbox {
  position: relative;
  float: left;
  cursor: pointer;
  color: #eaeaea;
  /*border-right: solid 1px #000;*/
  font-size: 14px;
}

.navTop__a--dropbox {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin-right: 15px;
  /*padding-left: 20px;*/
  color: #eaeaea;
  text-decoration: none;
}

.navTop__a--dropbox p {
  margin: 0;
  padding-left: 20px;
  line-height: 20px;
  border-left: 1px solid #CBCBCB
}

.navTop__dropbox--floatRight {
  height: 50px;
  float: right;
  color: #eaeaea;
  cursor: pointer;
  padding-right: 25px;
}

.navTop__dropdownMenu {
  z-index: 11000 !important;
}

.navTop__dropdownMenu.el-popper {
  margin-top: 0px;
}

.navTop__icon--floatRight {
  height: 50px;
  float: right;
  color: #eaeaea;
  cursor: pointer;
  padding-right: 25px;
}

.navTop__dropbox--floatRight i {
  margin-left: 4px; 
}

.navTop__icon--floatRight i {
  font-size: 18px; 
  vertical-align: middle;
  color: #fff;
}

.navTop__regionDropdown {
  background: rgba(247, 247, 248, 0.1);
  display: block;
  width: 150px;
  height: 30px;
  margin-top: 10px;
  border-radius: 5px;
  text-align: left;
  line-height: 30px;
  position: relative;
  cursor: pointer;
}

.navTop__regionDropdown>div {
  color: #eaeaea;
  margin-left: 20px;
  width: calc(100% - 57px);
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}

.navTop__regionDropdown .icon-map_marker {
    color: #fff;
    position: absolute;
    left: 6px;
    top: 9px;
}

.navTop__regionDropdown .el-icon-arrow-down {
    color: #c6c4cd;
    font-size: 12px;
    transform: scale(0.66, 0.42);
    position: absolute;
    top: 9px;
    right: 12px;
}

.navTop__msg {
  font-size: 14px;
  margin: 20px 20px 0px 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #bcbcbc;
}

.navTop__account {
  display: inline-block;
  color: rgb(244, 181, 100);
  font-size: 22px;
  cursor: pointer;
  margin: 10px 0;
}

.dropdown-item {
  margin: 10px 5px;
  font-size:14px;
  font-family:Microsoft YaHei;
  font-weight:400;
}

.navTop_jumpBtn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #383940;
  color: #999;
  background: #171921;
  margin-right: 1px;
  padding: 8px 20px;
  border-radius: 0;
  font-size: 12px;
}

.navTop_jumpBtn:hover {
  color: #00a0ff;
  background: #171921;
  border: 1px solid #383940;
}

.navTop__user {
  position: absolute;
  top: 0;
  right: 0px;
}

.navTop__userAvatar:hover {
  background-color: #1362C6;
}

.navTop__userAvatar {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  /*max-width: 80px;*/
  width: 80px;
  padding: 0 10px;
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-image: url(../../assets/images/headSculpture.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 27px 27px;
  cursor: pointer;
}

.navTop__userPop {
  overflow: hidden;
  text-align: center;
  min-width: 240px;
  color: #333;
  position: relative;
  font-size: 12px;
}

.navTop__username {
  text-align: left;
  margin-left: 20px;
}

.navTop__entranceLogo {
  font-size: 20px;
  margin: 8px auto 4px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  display: block;
}

.navTop__userEntrance {
  width: 80px;
  height: 80px;
  float: left;
  text-align: center;
  color: #999;
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
}

.navTop__userEntrance:hover {
  color: #00a0ff;
}

.navTop__logout {
  font-size: 12px;
  margin: 12px -10px -12px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #333;
  border-top: 1px solid #bcbcbc;
  cursor: pointer;
}

.navTop__logout:hover {
  color: #00a0ff;
}

.navAllPanelFade-enter-active,
.navAllPanelFade-leave-active {
  transition: all .2s ease-in-out 0s;
}

.navAllPanelFade-enter,
.navAllPanelFade-leave-to {
  opacity: 0;
}

/*修改ElementUI原生样式*/
.el-dropdown {
  color: #eaeaea;
  font-size: 14px;
}

.el-dropdown-menu {
  margin-top: -1px;
  /*padding: 5px !important;*/
  border: none;
  border-radius: 0;
  box-shadow:0px 0px 6px 0px rgba(25,38,75,0.25);
  background: #f2f3f6;
  padding: 0;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100px;
}

.el-dropdown-menu /deep/ .popper__arrow {
  display: none;
}

.el-dropdown-menu__item {
  font-size: 12px;
  padding: 0 10px;
  color: #555;
}
.el-dropdown-menu__item.is-disabled{
  color: #bbb !important;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  /*background-color: #171921;*/
  color: #2587f6;
}

.el-badge /deep/ sup {
  background-color: rgba(236, 103, 11, 1);
}

.el-badge /deep/ .el-badge__content {
  border: none;
}

.el-badge /deep/ .el-badge__content.is-fixed.is-dot {
  top: 12px;
  right: 5px;
}

@media screen and (max-width: 600px) {
  .navTop__icon--floatRight, .navTop__dropbox--floatRight {
    display: none;
  }
}
</style>

<style>
.navTop__popover {
  background: #f2f3f6 !important;
  margin-top: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  z-index: 2001 !important;
}
.message-content {
  /*color: #babdc4;*/
  margin: 0;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}

.item.el-badge .el-badge__content.is-fixed.is-dot {
  top: 12px;
  right: 20px;
}
  

</style>